<template>
  <q-btn
    round
    dense
    flat
    icon="mdi-help-circle-outline"
    :size="dense ? '10px' : undefined"
    :padding="dense ? 'none' : undefined"
    @click="openMenu"
  >
    <q-tooltip>Help Center</q-tooltip>
  </q-btn>
</template>

<script>
/**
 * Default Help Center button which will either filter the results to an option provided, or simply toggle the Help Center
 */
export default {
  props: {
    // Automatically filter the Help Center options to the specified string
    filter: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openMenu () {
      if (!this.filter) {
        this.$bus.emit('help:toggle', true)
      }
      else {
        this.$bus.emit('help:search', this.filter)
      }
    }
  }
}
</script>
